/*eslint-disable*/
//run this function
export default function showSingleYAML() {
  const showSingle = () => {
    const allYAMLS = document.querySelectorAll(
      "cart-drawer-products-recommendation",
    );
  
    const lasCartItemElement = document.querySelector("cart-items ul");
    if (!lasCartItemElement) {
      console.log("No cart item found");
      return;
    }
    const lastCartItem = document.querySelector("cart-items ul").lastElementChild;
  
    if (allYAMLS.length === 0 || !lastCartItem) {
      console.log("No YAMLs or last cart item found");
      return;
    }
  
    allYAMLS.forEach((yaml) => {
      yaml.style.display = "none";
    });
  
    setTimeout(() => {
      const filteredYAMLS = Array.from(allYAMLS).filter((yaml) => {
        const swiperWrapper = yaml.querySelector(".swiper-wrapper");
        return swiperWrapper && swiperWrapper.children.length > 0;
      });
  
      if (filteredYAMLS.length === 0) {
        console.log("No YAMLs with the required class found");
        return;
      }
  
      const randomIndex = Math.floor(Math.random() * filteredYAMLS.length);
      const lastYAML = filteredYAMLS[randomIndex];
  
      lastYAML.style.display = "flex";
  
      const cartRecommendation = lastCartItem.querySelector(
        "cart-drawer-products-recommendation",
      );
      if (cartRecommendation) {
        lastCartItem.replaceChild(lastYAML, cartRecommendation);
      }
    }, 1000);
  }

  document.addEventListener('recommendations:loaded', showSingle)
  document.addEventListener('cart:updated', showSingle)
}
  